<script setup lang="ts">
import type { ContestantAndRaceContestantTime } from '@/objects/generated';
import { millisecondsToFormattedTime } from '@/utilities/dateutils';

const props = defineProps<{
    value: number | null;

    row?: ContestantAndRaceContestantTime;
}>();
</script>
<template>
    <div
        v-if="value"
        class="text-end font-monospace"
        :class="{
            'fst-italic': props.row?.TimeType === 'ContestantTime',
        }"
    >
        {{ millisecondsToFormattedTime(value, 'TIMEMS3') }}
    </div>
</template>
